// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"392b9c69","732":"58446706"}[chunkId] + ".chunk.js";
};